import { Table } from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const FFIEC009AuditLog = ({
    data, columns,
}) => (
    <div className="true-comply-result__auditlog">
        {data && (
            <Row>
                <Col>
                    <div className="table-demo a-apply-theme-background-gray-level-1">
                        <Table
                            data={data}
                            columns={columns}
                            showPageSizeOptions={false}
                            defaultPageSize={10}
                            resizable
                            noDataText="No Audit Logs ..!!!"
                        />
                    </div>
                </Col>
            </Row>
        )}
    </div>
);

export default FFIEC009AuditLog;
